import en from "./en"

export default function getLanguage(language: string) {
    return {
        en: en
    }[language] ?? en;
};